"use client"

import { Custom500 } from "@/component-nextv3/500Page";

export default Custom500;